const state = {
    jdlbTypeId: sessionStorage.getItem("jdlbTypeId") || 1,
    jdlbTypeName: sessionStorage.getItem("jdlbTypeName") || "科技场馆",
    comInfo: JSON.parse(sessionStorage.getItem("comInfo") || '[]'),
    reportTaskInfo: JSON.parse(sessionStorage.getItem("reportTaskInfo") || '[]'),
    declareStepStatus: sessionStorage.getItem("declareStepStatus") || 1,
    nowStepStatus: sessionStorage.getItem("nowStepStatus") || 1,
    stepId: sessionStorage.getItem("stepId") || null
};

const mutations = {
    SET_JDLB_TYPE_ID: (state, jdlbTypeId) => {
        state.jdlbTypeId = jdlbTypeId;
        sessionStorage.setItem("jdlbTypeId", jdlbTypeId);
    },
    SET_JDLB_TYPE_NAME: (state, jdlbTypeName) => {
        state.jdlbTypeName = jdlbTypeName;
        sessionStorage.setItem("jdlbTypeName", jdlbTypeName);
    },
    SET_COM_INFO: (state, comInfo) => {
        state.comInfo = comInfo;
        sessionStorage.setItem("comInfo", JSON.stringify(comInfo));
    },
    SET_REPORT_TASK_INFO: (state, reportTaskInfo) => {
        state.reportTaskInfo = reportTaskInfo;
        sessionStorage.setItem("reportTaskInfo", JSON.stringify(reportTaskInfo));
    },
    SET_REPORT_TASK_ID: (state, reportTaskId) => {
        state.reportTaskInfo.id = reportTaskId;
        sessionStorage.setItem("reportTaskInfo", JSON.stringify(state.reportTaskInfo));
    },
    SET_DECLARE_STEP_STATUS: (state, declareStepStatus) => {
        state.declareStepStatus = declareStepStatus;
        sessionStorage.setItem("declareStepStatus", declareStepStatus);
    },
    SET_NOW_STEP_STATUS: (state, nowStepStatus) => {
        state.nowStepStatus = nowStepStatus;
        sessionStorage.setItem("nowStepStatus", nowStepStatus);
    },
    SET_STEP_ID: (state, stepId) => {
        state.stepId = stepId;
        sessionStorage.setItem("stepId", stepId);
    }
};

const actions = {
    setJdlbTypeId({ commit }, jdlbTypeId) {
        commit("SET_JDLB_TYPE_ID", jdlbTypeId);
    },
    setJdlbTypeName({ commit }, jdlbTypeName) {
        commit("SET_JDLB_TYPE_NAME", jdlbTypeName);
    },
    setComInfo({ commit }, comInfo) {
        commit("SET_COM_INFO", comInfo);
    },
    setReportTaskInfo({ commit }, reportTaskInfo) {
        commit("SET_REPORT_TASK_INFO", reportTaskInfo);
    },
    setReportTaskId({ commit }, reportTaskId) {
        commit("SET_REPORT_TASK_ID", reportTaskId);
    },
    setDeclareStepStatus({ commit }, declareStepStatus) {
        commit("SET_DECLARE_STEP_STATUS", declareStepStatus);
    },
    setNowStepStatus({ commit }, nowStepStatus) {
        commit("SET_NOW_STEP_STATUS", nowStepStatus);
    },
    setStepId({ commit }, stepId) {
        commit("SET_STEP_ID", stepId);
    }
};
export default {
    namespaced: true,
    state,
    mutations,
    actions
};
